import React from 'react';
import { Callout, Step, CodeBlock, DocHeading } from './components';

function PageInstallation() {
  return (
    <div>
      <h1 className="text-[2.5rem] leading-[1.1] font-semibold text-white tracking-[-0.02em] mb-3">Installation</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Follow these steps carefully to install MortisEngine. Do not skip any step.
      </p>

      <Callout type="info">
        Before continuing, make sure you have reviewed the <strong>System Requirements</strong> page
        and that all required software is installed.
      </Callout>

      <DocHeading>Step-by-Step Guide</DocHeading>

      <Step n={1} title="Download the loader">
        Log in to your account and go to your <strong>Dashboard</strong>. Download the latest
        version of the MortisEngine loader from the panel. The file will be a{' '}
        <code className="code-inline">.zip</code> archive.
      </Step>

      <Step n={2} title="Extract the archive">
        Extract the contents to a dedicated folder. Avoid paths with special characters or spaces
        (e.g. use{' '}
        <code className="code-inline">C:\MortisEngine</code>).
        <Callout type="warning">
          Do not run the loader from inside the zip archive — always extract first.
        </Callout>
      </Step>

      <Step n={3} title="Whitelist the folder in Windows Defender">
        Windows Defender may flag the loader as a false positive. Add the extraction folder
        to the Windows Defender exclusions list before launching.
        <CodeBlock>{`Windows Security → Virus & threat protection
→ Manage settings → Exclusions → Add an exclusion → Folder
→ Select: C:\\MortisEngine`}</CodeBlock>
      </Step>

      <Step n={4} title="Launch the game first">
        Start Drakensang Online and log in to your character. The bot must be injected into
        a running game session — it will not work if the game is not running.
      </Step>

      <Step n={5} title="Run mortis_engine.exe as Administrator">
        Right-click <code className="code-inline">mortis_engine.exe</code>{' '}
        → <strong>Run as administrator</strong>. A Login window will appear.
      </Step>

      <Step n={6} title="Log in with your website credentials">
        Enter your <strong>username</strong> and <strong>password</strong> — the same ones you
        use on this site. After a successful login the Dashboard is shown, displaying your HWID
        and current subscription status.
      </Step>

      <Step n={7} title="Press Inject">
        Click the <strong>Inject</strong> button. The loader downloads the required assets,
        locates <code className="code-inline">dro_client64.exe</code>,
        and injects the cheat. When done the status changes to{' '}
        <code className="code-inline">[OK] Success!</code>.
        <Callout type="warning">
          Keep the loader running while farming. Closing it also stops the bot immediately.
        </Callout>
      </Step>

      <Step n={8} title="Press INSERT in the game">
        Switch to the game window and press <strong>INSERT</strong>. The MortisEngine menu appears
        over the game, with a green <strong>ACTIVE</strong> in its header. That is the bot itself
        &mdash; see <strong>First Run</strong> for what the tabs are and which feature to turn on
        first.
      </Step>

      <Callout type="success">
        If the loader shows the Dashboard after login, injection completes without errors, and
        INSERT opens the menu in the game, the installation was successful.
      </Callout>
    </div>
  );
}

export default PageInstallation;
